/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { WarningCircleIcon16Light } from './WarningCircleIcon16Light';
import { WarningCircleIcon16Regular } from './WarningCircleIcon16Regular';
import { WarningCircleIcon16Solid } from './WarningCircleIcon16Solid';
import { WarningCircleIcon20Light } from './WarningCircleIcon20Light';
import { WarningCircleIcon20Regular } from './WarningCircleIcon20Regular';
import { WarningCircleIcon20Solid } from './WarningCircleIcon20Solid';
import { WarningCircleIcon24Regular } from './WarningCircleIcon24Regular';
import { WarningCircleIcon24Solid } from './WarningCircleIcon24Solid';
import { WarningCircleIcon32Regular } from './WarningCircleIcon32Regular';
import { WarningCircleIcon64Regular } from './WarningCircleIcon64Regular';
var sizes = {
    16: {
        light: WarningCircleIcon16Light,
        regular: WarningCircleIcon16Regular,
        solid: WarningCircleIcon16Solid,
    },
    20: {
        light: WarningCircleIcon20Light,
        regular: WarningCircleIcon20Regular,
        solid: WarningCircleIcon20Solid,
    },
    24: {
        regular: WarningCircleIcon24Regular,
        solid: WarningCircleIcon24Solid,
    },
    32: {
        regular: WarningCircleIcon32Regular,
    },
    64: {
        regular: WarningCircleIcon64Regular,
    },
};
export var WarningCircleIcon = forwardRef('WarningCircleIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
